import React, { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, Users, Search } from "lucide-react";
import { Tooltip } from "@mui/material";
import axios from "axios";
import { base_url } from "../../utils/AxiosConfig";
import user1 from "../../images/ic_no_person_photo.svg";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import InactiveTeams from "./InactiveTeams";
import BusinessIcon from "@mui/icons-material/Business";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
dayjs.extend(relativeTime);

const TeamManagement = ({
  formData,
  setFormData,
  onSaveTeamParent,
  teams,
  setTeams,
  editingTeamBoolean,
  setEditingTeamBoolean,
  fetchActiveList,
}) => {
  // console.log("teams in active teams:", teams);
  // console.log("teams members in active teams:", teams?.[0]?.members);

  const users = [
    "Ahmed Khan",
    "Fatima Alavi",
    "Raghu",
    "Suresh",
    "Maria",
    "John",
    "Priya",
    "Omar Hassan",
    "Lakshmi",
    "Carlos",
  ];

  const roles = [
    "Team Lead",
    "Senior Employee",
    "Employee",
    "Intern",
    "HR Coordinator",
    "Supervisor",
  ];

  const departments = [
    "Human Resources",
    "Technology",
    "Finance",
    "Sales",
    "Marketing",
    "Operations",
    "Customer Support",
  ];

  const employeeStatus = [
    "Active",
    "On Leave",
    "Probation",
    "Notice Period",
    "Resigned",
    "Terminated",
  ];

  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [editingTeam, setEditingTeam] = useState();
  const [loader, setLoader] = useState(false);
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;
  const [searchdata, setSearchData] = useState("");
  const [resetalldata, setResetallData] = useState(false);
  const [allEmpRecords, setAllEmpRecords] = useState([]);
  const [jobCodeList, setJobCodeList] = useState([]);
  const [leaderSearch, setLeaderSearch] = useState("");
  const [memberSearch, setMemberSearch] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [teamToDelete, setTeamToDelete] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [isTeamNameEditable, setIsTeamNameEditable] = useState(false);
  const [pendingMember, setPendingMember] = useState(null);

  useEffect(() => {
    fetchActiveList();
    getEmployeeData();
    // getTeamCodeList();
    getTeamTypeList();
  }, []);

  const fetchProfilePic = (ImagePath) => {
    if (!ImagePath) return user1;
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  const openAddModal = () => {
    setEditingTeamBoolean(false);
    setEditingTeam(null);
    setFormData((prev) => ({
      name: "",
      TeamName: "",
      Division: prev.Division,
      description: "",
      TeamDescription: "",
      teamCode: "",
      TeamCode: "",
      teamType: "",
      TeamType: "",
      owner: null,
      TeamLeaderID: "",
      TeamLeaderName: "",
      members: [],
    }));
    setIsOpen(true);
  };

  const openEditModal = (team) => {
    console.log("Team in edit modal:", team);
    setEditingTeamBoolean(true);
    setEditingTeam(team);
    setFormData({
      ...team,
      name: team.TeamName || team.name || "",
      TeamName: team.TeamName || team.name || "",
      teamCode: team.TeamCode || team.teamCode || "",
      TeamCode: team.TeamCode || team.teamCode || "",
      teamType: team.TeamType || team.teamType || "",
      TeamType: team.TeamType || team.teamType || "",
      description: team.TeamDescription || team.description || "",
      TeamDescription: team.TeamDescription || team.description || "",
      TeamLeaderID: team.TeamLeaderID || team.owner?.ownerid || "",
      TeamLeaderName: team.TeamLeaderName || team.owner?.ownerName || "",
      owner: team.owner || {
        ownerid: team.TeamLeaderID,
        ownerName: team.TeamLeaderName,
      },
      members:
        team.members?.map((m) => ({
          ...m,
          employeeId: m.EmployeeID || m.employeeId,
          EmployeeID: m.EmployeeID || m.employeeId,
          name: m.EmployeeName || m.name,
          EmployeeName: m.EmployeeName || m.name,
          role: m.RoleInTeam || m.role,
          RoleInTeam: m.RoleInTeam || m.role,
        })) || [],
    });
    setIsOpen(true);
  };

  const saveTeam = () => {
    if (
      !(formData.TeamName || formData.name) ||
      !(formData?.TeamLeaderID || formData?.owner?.ownerid)
    )
      return;

    if (editingTeam) {
      setTeams((prev) =>
        prev.map((t) =>
          (t.TeamID || t.id) === (editingTeam.TeamID || editingTeam.id)
            ? { ...editingTeam, ...formData }
            : t,
        ),
      );
      onSaveTeamParent(editingTeamBoolean);
    } else {
      setTeams((prev) => [
        ...prev,
        {
          id: Date.now(),
          TeamID: Date.now(),
          ...formData,
        },
      ]);
      onSaveTeamParent(editingTeamBoolean);
    }

    setIsOpen(false);
  };

  const deleteTeam = () => {
    if (!teamToDelete) return;

    setTeams((prev) =>
      prev.filter(
        (t) => (t.TeamID || t.id) !== (teamToDelete.TeamID || teamToDelete.id),
      ),
    );

    setDeleteModalOpen(false);
    setTeamToDelete(null);
  };

  const filteredTeams = teams?.filter((team) => {
    const searchValue = search?.toLowerCase();

    return (
      team.TeamName?.toLowerCase().includes(searchValue) ||
      team.TeamLeaderName?.toLowerCase().includes(searchValue) ||
      team.members?.some((m) =>
        (m.EmployeeName || m.name || "").toLowerCase().includes(searchValue),
      )
    );
  });

  const getEmployeeData = async () => {
    setLoader(true);
    try {
      const isSearchEmpty = !searchdata || searchdata.trim() === "";

      const searchType = isSearchEmpty || resetalldata ? "ALL" : "FREETEXT";
      const searchParam = isSearchEmpty || resetalldata ? "ALL" : searchdata;

      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/${searchType}/YES/${searchParam}/ALL/ALL/ALL`,
      );
      const data = response.data;
      console.log("Data Employee List:", data);
      setAllEmpRecords(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
      if (resetalldata) setResetallData(false);
    }
  };

  const toggleMember = async (user) => {
    const existing = formData.members?.find(
      (m) => (m.employeeId || m.EmployeeID) === user.EmpId,
    );

    if (existing) {
      setFormData({
        ...formData,
        members: formData.members?.filter(
          (m) => (m.employeeId || m.EmployeeID) !== user.EmpId,
        ),
      });
      return;
    }

    // Existing edit-team validation
    if (editingTeam) {
      const isInCurrentTeam = editingTeam.members?.some(
        (m) => (m.employeeId || m.EmployeeID) === user.EmpId,
      );

      // if (isInCurrentTeam) {
      //   setPendingMember(user);
      //   // setShowConfirmDialog(true);
      //   return;
      // }
    }

    // New API validation
    const existsInOtherTeam = await checkMemberExistsInOtherTeam(user.EmpId);

    if (existsInOtherTeam) {
      setPendingMember(user);
      setShowConfirmDialog(true);
      return;
    }

    addMemberToTeam(user);
  };

  const checkMemberExistsInOtherTeam = async (empId) => {
    try {
      const storeduserDataArray =
        JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

      const companyCode = storeduserDataArray?.[0]?.cmpcode || "";

      const response = await axios.get(
        `${base_url}/api/DupCheck/${companyCode}/TEAMCOUNT/${empId}`,
      );

      const count = Number(response?.data?.[0]?.COUNT || 0);

      return count > 0;
    } catch (error) {
      console.error("Error checking team member:", error);
      return false;
    }
  };

  const addMemberToTeam = (user) => {
    setFormData({
      ...formData,
      members: [
        ...(formData.members || []),
        {
          employeeId: user.EmpId,
          EmployeeID: user.EmpId,
          name: user.Name,
          EmployeeName: user.Name,
          designation: user.JobTitle || "Employee",
          role: user.Division || "Member",
          RoleInTeam: user.Division || "Member",
          status: "Active",
          employeeImage: user.imagepath || null,
          isActive: true,
        },
      ],
    });
  };

  const confirmAddDuplicate = () => {
    if (pendingMember) {
      addMemberToTeam(pendingMember);
      setShowConfirmDialog(false);
      setPendingMember(null);
    }
  };

  const updateRole = (employeeId, newRole) => {
    setFormData({
      ...formData,
      members: formData?.members?.map((member) =>
        (member.employeeId || member.EmployeeID) === employeeId
          ? { ...member, RoleInTeam: newRole, role: newRole }
          : member,
      ),
    });
  };

  const selectedLeader = allEmpRecords.find(
    (emp) => emp.EmpId === (formData?.TeamLeaderID || formData?.owner?.ownerid),
  );

  const ConfirmationDialog = () => {
    if (!showConfirmDialog) return null;

    return (
      <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50">
        <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl animate-in fade-in zoom-in duration-200">
          <div className="text-center">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100">
              <svg
                className="h-6 w-6 text-yellow-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <h3 className="mb-2 text-xl font-semibold text-slate-800">
              Member Already Exists
            </h3>
            <p className="mb-6 text-slate-600">
              <span className="font-medium">{pendingMember?.Name}</span> (
              {pendingMember?.EmpId})
              <br />
              is already a member of other team.
              <br />
              Do you still want to add them?
            </p>
            <div className="flex gap-3">
              <button
                onClick={() => {
                  setShowConfirmDialog(false);
                  setPendingMember(null);
                }}
                className="flex-1 rounded-xl border border-slate-300 px-4 py-2 font-medium text-slate-700 transition hover:bg-slate-50"
              >
                Cancel
              </button>
              <button
                onClick={confirmAddDuplicate}
                className="flex-1 rounded-xl bg-yellow-600 px-4 py-2 font-medium text-white transition hover:bg-yellow-700"
              >
                Yes, Add Anyway
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const isEmployeeInAnyTeam = (employeeId, currentTeamId = null) => {
    return teams?.some(
      (team) =>
        (team.TeamID || team.id) !== currentTeamId &&
        team.members?.some(
          (member) => (member.employeeId || member.EmployeeID) === employeeId,
        ),
    );
  };

  const toggleMemberWithGlobalCheck = (user) => {
    const existing = formData.members?.find(
      (m) => (m.employeeId || m.EmployeeID) === user.EmpId,
    );

    if (existing) {
      setFormData({
        ...formData,
        members: formData.members?.filter(
          (m) => (m.employeeId || m.EmployeeID) !== user.EmpId,
        ),
      });
    } else {
      if (!editingTeam && isEmployeeInAnyTeam(user.EmpId)) {
        setPendingMember(user);
        setShowConfirmDialog(true);
        return;
      }
      addMemberToTeam(user);
    }
  };

  const availableMembers = allEmpRecords.filter(
    (emp) => emp.EmpId !== (formData?.TeamLeaderID || formData?.owner?.ownerid),
  );

  const toggleTeamStatus = async (teamId, currentStatus) => {
    try {
      const storeduserDataArray =
        JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

      const companyCode = storeduserDataArray?.[0]?.cmpcode || "";

      const newStatus = currentStatus === "Y" ? "N" : "Y";

      await axios.get(
        `${base_url}/api/CRMStatusUpdate/${companyCode}/TEAMACTIVE/${teamId}/${newStatus}`,
      );

      setTeams((prev) =>
        prev.map((team) =>
          (team.TeamID || team.id) === teamId
            ? {
                ...team,
                ActiveStatus: newStatus,
                isActive: newStatus === "Y",
              }
            : team,
        ),
      );

      console.log("updated team status:");
      // setSnackbar({
      //   open: true,
      //   message: `Team ${
      //     newStatus === "Y" ? "activated" : "deactivated"
      //   } successfully`,
      //   severity: "success",
      // });
      fetchActiveList();
    } catch (error) {
      console.error("Error updating team status:", error);

      // setSnackbar({
      //   open: true,
      //   message: "Failed to update team status",
      //   severity: "error",
      // });
    }
  };

  const filteredLeaders = [...allEmpRecords]
    .filter((emp) => {
      const searchVal = leaderSearch.toLowerCase();

      return (
        emp.Name?.toLowerCase().includes(searchVal) ||
        emp.EmpId?.toLowerCase().includes(searchVal) ||
        emp.Department?.toLowerCase().includes(searchVal) ||
        emp.JobTitle?.toLowerCase().includes(searchVal)
      );
    })
    .sort((a, b) => {
      const leaderId = formData?.TeamLeaderID || formData?.owner?.ownerid;
      if (a.EmpId === leaderId) return -1;
      if (b.EmpId === leaderId) return 1;
      return 0;
    });

  const filteredMembers = allEmpRecords
    .filter((emp) => {
      const searchVal = memberSearch.toLowerCase();
      const leaderId = formData?.TeamLeaderID || formData?.owner?.ownerid;

      return (
        emp.EmpId !== leaderId &&
        (emp.Name?.toLowerCase().includes(searchVal) ||
          emp.EmpId?.toLowerCase().includes(searchVal) ||
          emp.Department?.toLowerCase().includes(searchVal) ||
          emp.JobTitle?.toLowerCase().includes(searchVal))
      );
    })
    .sort((a, b) => {
      const aSelected = formData.members?.some(
        (m) => (m.employeeId || m.EmployeeID) === a.EmpId,
      );
      const bSelected = formData.members?.some(
        (m) => (m.employeeId || m.EmployeeID) === b.EmpId,
      );

      if (aSelected && !bSelected) return -1;
      if (!aSelected && bSelected) return 1;

      return a.Name.localeCompare(b.Name);
    });

  const closeTeamCreationModal = () => {
    setFormData((prev) => ({
      name: "",
      TeamName: "",
      owner: null,
      TeamLeaderID: "",
      TeamLeaderName: "",
      teamCode: "",
      TeamCode: "",
      teamType: "",
      TeamType: "",
      members: [],
      date: new Date(),
      CreatedDate: new Date().toISOString(),
      isActive: true,
      ActiveStatus: "Y",
      Division: prev.Division,
    }));
    setTeamNameError("");
    setIsOpen(false);
  };

  const [showMasterPopup, setShowMasterPopup] = useState(false);
  const [masterType, setMasterType] = useState(""); // TEAM_CODE | TEAM_TYPE
  const [masterInputNew, setMasterInputNew] = useState({ description: "" });
  const [masterInputEdit, setMasterInputEdit] = useState({
    description: "",
    transaction_id: "",
  });

  const [teamCodeListFromAPI, setTeamCodeListFromAPI] = useState([]);
  const [teamTypeListFromAPI, setTeamTypeListFromAPI] = useState([]);
  const [teamNameDuplicate, setTeamNameDuplicate] = useState(false);
  const [teamNameError, setTeamNameError] = useState("");
  const [checkingTeamName, setCheckingTeamName] = useState(false);

  // useEffect(()=>{
  //   console.log("teamNameDuplicate:",teamNameDuplicate)
  // },[teamNameDuplicate])

  const teamCodeList = [];
  const teamTypeList = [];

  const createTeamCode = () => {
    const apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/TEAMCODE/${masterInputNew.description}/0`;

    axios
      .post(apiUrl)
      .then((res) => {
        getTeamCodeList();

        setMasterInputNew({
          description: "",
        });
      })
      .catch((err) => {
        console.error("Error creating Team Code:", err);
      });
  };

  const createTeamType = () => {
    const apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/TEAMTYPE/${masterInputNew.description}/0`;

    axios
      .post(apiUrl)
      .then((res) => {
        getTeamTypeList();

        setMasterInputNew({
          description: "",
        });
      })
      .catch((err) => {
        console.error("Error creating Team List:", err);
      });
  };
  const getTeamCodeList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/TEAMCODE/-`,
    );
    if (response?.data) {
      const data = response.data;
      console.log("Team code List:", data);
      setTeamCodeListFromAPI(data);
    } else {
      console.log("error");
    }
  };

  const getTeamTypeList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/TEAMTYPE/-`,
    );
    if (response?.data) {
      const data = response.data;
      console.log("Team type List:", data);
      setTeamTypeListFromAPI(data);
    } else {
      console.log("error");
    }
  };

  const updateTeamCode = () => {
    console.log("Update Team Code", masterInputEdit);
  };

  const updateTeamType = () => {
    console.log("Update Team Type", masterInputEdit);
  };

  // Master lists filtered to remove empty descriptions
  const filteredTeamCodes = teamCodeListFromAPI?.filter(
    (item) => item && item.Description && item.Description.trim() !== "",
  );

  const filteredTeamTypes = teamTypeListFromAPI?.filter(
    (item) => item && item.Description && item.Description.trim() !== "",
  );

  const activeMasterList =
    masterType === "TEAM_CODE" ? filteredTeamCodes : filteredTeamTypes;

  const checkDuplicateTeamName = async (teamName) => {
    if (!teamName?.trim()) {
      setTeamNameError("");
      return true;
    }

    try {
      setCheckingTeamName(true);

      const storeduserDataArray =
        JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

      const companyCode = storeduserDataArray?.[0]?.cmpcode || "";

      const response = await axios.get(
        `${base_url}/api/DupCheck/${companyCode}/TEAMNAME/${formData.TeamName || formData.name}`,
      );

      console.log("Response of dup check:", response.data[0].COUNT);
      // Adjust according to API response
      const isDuplicate = response.data[0].COUNT === 1;

      if (isDuplicate) {
        setTeamNameDuplicate(true);
        setTeamNameError("Team Name Already Exists!");
        return false;
      }

      setTeamNameDuplicate(false);
      setTeamNameError("");
      return true;
    } catch (error) {
      console.error("Duplicate team name check failed:", error);
      return true;
    } finally {
      setCheckingTeamName(false);
    }
  };

  const disableSaveTeam =
    !(formData?.TeamName || formData?.name) ||
    !(formData?.TeamLeaderID || formData?.owner?.ownerid) ||
    !formData?.Division ||
    teamNameDuplicate;
  const disableEditTeam =
    !(formData?.TeamName || formData?.name) ||
    !(formData?.TeamLeaderID || formData?.owner?.ownerid);
  const isButtonDisabled = editingTeam ? disableEditTeam : disableSaveTeam;

  useEffect(() => {
    console.log("teamNameError:", teamNameError);
  }, [teamNameError]);

  return (
    <div className="min-h-screen p-6">
      {/* Header */}
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        {teams?.length === 0 ? (
          ""
        ) : (
          <div className="relative w-[50%]">
            <Search className="absolute left-3 top-3 text-gray-400" size={18} />
            <input
              type="text"
              placeholder="Search teams, owner or members..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full rounded-xl border bg-white py-2 pl-10 pr-4 outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        )}
        {filteredTeams?.length === 0 ? (
          ""
        ) : (
          <Tooltip
            title={
              !formData?.Division
                ? "Select Division before creating a team"
                : "Create a new team"
            }
            arrow
          >
            <span>
              <button
                disabled={!formData?.Division}
                onClick={() => {
                  setIsTeamNameEditable(true);
                  openAddModal();
                }}
                className={`text-sm flex items-center gap-2 rounded-lg py-2 px-4 font-medium text-white transition
                  ${
                    !formData?.Division
                      ? "cursor-not-allowed bg-gray-400"
                      : "bg-green-600 hover:bg-green-700"
                  }`}
              >
                <Plus size={18} />
                Create Team
              </button>
            </span>
          </Tooltip>
        )}
      </div>

      {/* Cards */}
      {filteredTeams?.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            className="h-40 w-40 text-slate-300"
            fill="currentColor"
          >
            <path d="M256 256a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm0 32c-79.5 0-144 64.5-144 144a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16c0-79.5-64.5-144-144-144zm160-32a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm0 32c-19.6 0-38.2 4.2-55 11.7 33.6 28.5 55 71 55 119.3v13h80a16 16 0 0 0 16-16c0-70.7-57.3-128-128-128zM96 256a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm55 43.7C134.2 292.2 115.6 288 96 288-25.7 288-83 345.3-83 416a16 16 0 0 0 16 16h80v-13c0-48.3 21.4-90.8 55-119.3z" />
          </svg>
          <h3 className="mt-6 text-2xl font-semibold text-slate-700">
            No Teams Found
          </h3>
          <p className="mt-2 max-w-md text-center text-slate-500">
            There are currently no teams available. Create a new team to start
            assigning leaders and members.
          </p>
          <button
            onClick={() => {
              setEditingTeam(null);
              setIsTeamNameEditable(true);
              setIsOpen(true);
            }}
            className="mt-6 rounded-xl bg-green-600 px-5 py-2.5 font-medium text-white transition hover:bg-green-700"
          >
            Create Team
          </button>
        </div>
      ) : (
        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {filteredTeams?.map((team) => {
            const isTeamActive = team.isActive || team.ActiveStatus === "Y";
            return (
              <div
                key={team.TeamID || team.id}
                className={`rounded-2xl border bg-white px-3 py-2 transition hover:shadow-lg
                  ${
                    isTeamActive
                      ? "border-white/30"
                      : "border-red-200 bg-gray-100 opacity-70"
                  }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-bold">{team.TeamName}</h3>
                    <h5 className="text-xs font-thin">
                      {team.TeamDescription}
                    </h5>

                    <div className="flex gap-2 items-center mt-2 w-full rounded">
                      <span className="text-sm text-gray-900">Leader:</span>{" "}
                      <img
                        className="h-6 w-6 rounded-full object-cover"
                        src={
                          team.imagepath
                            ? fetchProfilePic(team.imagepath)
                            : user1
                        }
                        alt=""
                      />
                      <div className="flex gap-2 items-center">
                        <span className="text-sm text-gray-900 font-medium">
                          {team.TeamLeaderName || team.owner?.ownerName} -
                          <span className="font-thin text-xs">
                            ({team.TeamLeaderID || team.owner?.ownerid})
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-right items-right gap-2">
                    <span
                      className={`rounded-full px-3 py-1 text-xs text-center font-medium ${
                        isTeamActive
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-200 text-gray-800"
                      }`}
                    >
                      {isTeamActive ? "Active" : "Inactive"}
                    </span>
                    <span className="rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700">
                      {team.members?.length || 0} members
                    </span>
                  </div>
                </div>
                <div className="mt-3 space-y-2 max-h-40 overflow-auto scrollbar-none">
                  {team.members?.map((member) => (
                    <div
                      key={
                        member.EmployeeID ||
                        member.employeeId ||
                        member.EmployeeName ||
                        member.name
                      }
                      className="flex items-center justify-between rounded-lg bg-gray-50 px-2 py-1 border border-gray-200"
                    >
                      <img
                        className="h-10 w-10 rounded-full object-cover"
                        src={
                          member.imagepath
                            ? fetchProfilePic(member.imagepath)
                            : user1
                        }
                        alt={member.EmployeeName || member.name}
                        onError={(e) => {
                          e.target.src = user1;
                        }}
                      />
                      <span className="text-sm font-medium">
                        {member.EmployeeName || member.name}
                      </span>
                      <span className="rounded bg-orange-100 px-2 py-1 text-xs text-orange-700">
                        {member.RoleInTeam || member.role}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="mt-2 flex items-center justify-between gap-3">
                  <p className="text-left  text-xs text-gray-500">
                    Created {dayjs(team.CreatedDate || team.date).fromNow()} •{" "}
                    {dayjs(team.CreatedDate || team.date).format("DD MMM YYYY")}
                  </p>
                  <div className="flex items-center justify-end gap-2">
                    <label className="relative inline-flex cursor-pointer items-center">
                      <input
                        type="checkbox"
                        checked={isTeamActive}
                        onChange={() =>
                          toggleTeamStatus(
                            team.TeamID || team.id,
                            team.ActiveStatus || (team.isActive ? "Y" : "N"),
                          )
                        }
                        className="peer sr-only"
                      />
                      <div
                        className="peer h-6 w-11 rounded-full bg-gray-300
      after:absolute after:left-[2px] after:top-[2px]
      after:h-5 after:w-5 after:rounded-full
      after:bg-white after:transition-all
      peer-checked:bg-green-500
      peer-checked:after:translate-x-5"
                      />
                    </label>
                    <button
                      disabled={!isTeamActive}
                      onClick={() => {
                        setIsTeamNameEditable(false);
                        openEditModal(team);
                      }}
                      className="rounded-lg bg-blue-50 p-2 text-blue-600 hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <Pencil size={18} />
                    </button>
                    {/* Delete Button  */}
                    {/* <button
                    onClick={() => {
                      setTeamToDelete(team);
                      setDeleteModalOpen(true);
                    }}
                    className="rounded-lg bg-red-50 p-2 text-red-600 hover:bg-red-100"
                  >
                    <Trash2 size={18} />
                  </button> */}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {showConfirmDialog && <ConfirmationDialog />}

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/70 p-2 scrollbar-none">
          <div className="px-6 w-full max-w-4xl max-h-[80vh] overflow-hidden rounded-3xl bg-white shadow-2xl animate-in fade-in zoom-in duration-300">
            {/* Header */}
            <div className="sticky top-0 z-10 border-b bg-white p-4">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold text-slate-800">
                    {editingTeam ? "Edit Team" : "Create Team"}
                  </h2>
                  <p className="text-sm text-slate-500 mt-1">
                    Manage team members and assign responsibilities
                  </p>
                </div>
                <div className="">
                  <label className="mb-1 block text-xs font-medium text-slate-700">
                    Created On
                  </label>
                  <div className="relative">
                    <FiCalendar className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 text-lg pointer-events-none z-10" />
                    <DatePicker
                      selected={
                        formData.CreatedDate
                          ? new Date(formData.CreatedDate)
                          : formData.date
                            ? new Date(formData.date)
                            : new Date()
                      }
                      onChange={(date) =>
                        setFormData((prev) => ({
                          ...prev,
                          CreatedDate: date ? date.toISOString() : "",
                          date: date,
                        }))
                      }
                      dateFormat="dd/MM/yyyy"
                      className="
                        rounded-xl
                        border
                        border-gray-300
                        bg-white
                        p-2
                        pr-10
                        text-slate-700
                        outline-none
                        transition
                        hover:border-slate-400
                        focus:border-blue-500
                        focus:ring-4
                        focus:ring-blue-100
                      "
                    />
                  </div>
                </div>
                <button
                  onClick={closeTeamCreationModal}
                  className="h-10 w-10 rounded-full hover:bg-slate-100 text-slate-500"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Body */}
            <div className="overflow-y-auto max-h-[65vh] px-8 py-6">
              <div className="">
                <div>
                  <div className="mb-2 flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-slate-800">
                      Team Name
                    </h3>
                    <button
                      type="button"
                      onClick={() => setIsTeamNameEditable((prev) => !prev)}
                      className={`flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium transition ${
                        isTeamNameEditable
                          ? "bg-green-100 text-green-700"
                          : "bg-slate-100 text-slate-600"
                      }`}
                    >
                      <div
                        className={`h-2 w-2 rounded-full ${
                          isTeamNameEditable ? "bg-green-500" : "bg-slate-400"
                        }`}
                      />
                      {isTeamNameEditable ? "Editable" : "Locked"}
                    </button>
                  </div>
                  {/* <input
                    disabled={!isTeamNameEditable}
                    placeholder="Enter Team Name"
                    value={formData.TeamName || formData.name || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        TeamName: e.target.value,
                        name: e.target.value,
                      })
                    }
                    className={`w-full rounded-xl border p-2 outline-none transition ${
                      isTeamNameEditable
                        ? "border-slate-300 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                        : "cursor-not-allowed border-slate-200 bg-slate-100 text-slate-500"
                    }`}
                  /> */}
                  <input
                    disabled={!isTeamNameEditable}
                    placeholder="Enter Team Name"
                    value={formData.TeamName || formData.name || ""}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        TeamName: e.target.value,
                        name: e.target.value,
                      });

                      setTeamNameError("");
                    }}
                    onBlur={() => {
                      if (!editingTeam) {
                        checkDuplicateTeamName(
                          formData.TeamName || formData.name,
                        );
                      }
                    }}
                    className={`w-full rounded-xl border p-2 outline-none transition ${
                      teamNameDuplicate
                        ? "border-red-500 focus:border-red-500 focus:ring-4 focus:ring-red-100"
                        : isTeamNameEditable
                          ? "border-slate-300 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                          : "cursor-not-allowed border-slate-200 bg-slate-100 text-slate-500"
                    }`}
                  />

                  {checkingTeamName && (
                    <p className="mt-1 text-xs text-slate-500">
                      Checking team name...
                    </p>
                  )}

                  {teamNameError && !editingTeam && (
                    <p className="mt-2 text-xs text-red-600">{teamNameError}</p>
                  )}
                </div>

                <div className="mt-4 grid gap-4 md:grid-cols-2">
                  {/* Job Code */}
                  <div>
                    <label className="mb-2 block text-md font-semibold text-slate-700">
                      Job Code
                    </label>

                    <select
                      value={formData.JobCode || formData.jobCode || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          JobCode: e.target.value,
                          jobCode: e.target.value,
                        })
                      }
                      className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                    >
                      <option value="">Select Job Code</option>

                      {jobCodeList?.map((job) => (
                        <option
                          key={job.JobCode || job.jobCode || job.id}
                          value={job.JobCode || job.jobCode}
                        >
                          {(job.JobCode || job.jobCode) +
                            (job.JobDescription
                              ? ` - ${job.JobDescription}`
                              : job.jobDescription
                                ? ` - ${job.jobDescription}`
                                : "")}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Team Type */}
                  <div>
                    <label className="mb-2 block text-md font-semibold text-slate-700">
                      Team Type
                    </label>
                    <div className="flex items-center gap-2">
                      <select
                        value={formData.TeamType || formData.teamType || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            TeamType: e.target.value,
                            teamType: e.target.value,
                          })
                        }
                        className="flex-1 rounded-xl border border-slate-300 bg-white px-3 py-2.5 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                      >
                        <option value="">Select Team Type</option>
                        {filteredTeamTypes &&
                          filteredTeamTypes.length > 0 &&
                          filteredTeamTypes.map((item) => (
                            <option key={item.TranId} value={item.Description}>
                              {item.Description}
                            </option>
                          ))}
                      </select>
                      <button
                        type="button"
                        onClick={() => {
                          setMasterType("TEAM_TYPE");
                          setShowMasterPopup(true);
                        }}
                        className="whitespace-nowrap rounded-md bg-blue-600 p-1 text-xs font-medium text-white transition hover:bg-blue-700"
                      >
                        Add Type
                      </button>
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="mb-2 flex items-center justify-between">
                    <h3 className="text-md font-semibold text-slate-800">
                      Team Description
                    </h3>
                    <button
                      type="button"
                      onClick={() => setIsTeamNameEditable((prev) => !prev)}
                      className={`flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium transition ${
                        isTeamNameEditable
                          ? "bg-green-100 text-green-700"
                          : "bg-slate-100 text-slate-600"
                      }`}
                    >
                      <div
                        className={`h-2 w-2 rounded-full ${
                          isTeamNameEditable ? "bg-green-500" : "bg-slate-400"
                        }`}
                      />
                      {isTeamNameEditable ? "Editable" : "Locked"}
                    </button>
                  </div>
                  <textarea
                    disabled={!isTeamNameEditable}
                    rows={3}
                    placeholder="Enter Team Description"
                    value={
                      formData.TeamDescription || formData.description || ""
                    }
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        TeamDescription: e.target.value,
                        description: e.target.value,
                      })
                    }
                    className={`w-full resize-none rounded-xl border p-3 outline-none transition ${
                      isTeamNameEditable
                        ? "border-slate-300 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                        : "cursor-not-allowed border-slate-200 bg-slate-100 text-slate-500"
                    }`}
                  />
                </div>

                <div>
                  <div className="">
                    <h3 className="text-lg font-semibold text-slate-800 mt-4">
                      Team Leader
                    </h3>
                    {/* Search */}
                    <input
                      placeholder="Search leader..."
                      value={leaderSearch}
                      onChange={(e) => setLeaderSearch(e.target.value)}
                      className="my-2 w-full rounded-xl border border-slate-300 p-2 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                    />
                    <div className="max-h-48 bg-gray-50 border border-gray-300 overflow-y-auto scrollbar-none rounded-xl p-2 space-y-2">
                      {filteredLeaders.map((emp) => {
                        const selected =
                          formData?.TeamLeaderID === emp.EmpId ||
                          formData?.owner?.ownerid === emp.EmpId;
                        return (
                          <div
                            key={emp.EmpId}
                            onClick={() => {
                              setFormData((prev) => ({
                                ...prev,
                                TeamLeaderID: emp.EmpId,
                                TeamLeaderName: emp.Name,
                                owner: {
                                  ownerid: emp.EmpId,
                                  ownerName: emp.Name,
                                },
                                members: prev.members?.filter(
                                  (member) =>
                                    (member.EmployeeID ||
                                      member.employeeId ||
                                      member.EmpId) !== emp.EmpId,
                                ),
                              }));
                              setLeaderSearch("");
                            }}
                            className={`bg-white cursor-pointer flex items-center gap-4 rounded-xl border p-3 transition-all
                              ${
                                selected
                                  ? "border-blue-500 bg-blue-50"
                                  : "border-slate-200 hover:border-slate-300 hover:bg-slate-50"
                              }`}
                          >
                            <img
                              className="h-12 w-12 rounded-full object-cover"
                              src={
                                emp.imagepath
                                  ? fetchProfilePic(emp.imagepath)
                                  : user1
                              }
                              alt=""
                            />
                            <div className="flex-1">
                              <h4 className="font-medium text-slate-800">
                                {emp.Name}
                                <span className="ml-2 text-xs text-slate-400">
                                  ({emp.EmpId})
                                </span>
                              </h4>
                              <p className="text-sm text-slate-500">
                                {emp.JobTitle || "Employee"} •{" "}
                                {emp.Department || "No Department"}
                              </p>
                            </div>
                            {selected && (
                              <div className="flex items-center gap-2">
                                <div className="h-2.5 w-2.5 rounded-full bg-green-500" />
                                <span className="text-sm font-medium text-blue-600">
                                  Leader
                                </span>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              {/* Members */}
              <div>
                <div className="mt-4 mb-2 flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold text-slate-800">
                      Team Members
                    </h3>
                  </div>
                  <span className="rounded-full bg-blue-100 px-4 py-1 text-sm font-medium text-blue-700">
                    {formData?.members?.length || 0} Selected
                  </span>
                </div>
                {/* Search */}
                <input
                  placeholder="Search ..."
                  value={memberSearch}
                  onChange={(e) => setMemberSearch(e.target.value)}
                  className="mb-2 w-full rounded-xl border border-slate-300 p-2 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                />
                <div className="max-h-60 border border-gray-300 p-2 bg-gray-50 rounded-lg overflow-y-auto scrollbar-none">
                  <div className="space-y-2 ">
                    {filteredMembers?.map((user) => {
                      const selected = formData?.members?.find(
                        (m) => (m.EmployeeID || m.employeeId) === user.EmpId,
                      );
                      return (
                        <div
                          onClick={() => {
                            setMemberSearch("");
                            toggleMember(user);
                          }}
                          key={user.EmpId}
                          className={`flex bg-white items-center gap-4 rounded-2xl border p-2 transition-all duration-200 
                            ${
                              selected
                                ? "border-blue-500 bg-blue-50"
                                : "border-slate-200 hover:border-slate-300 hover:bg-slate-50"
                            }`}
                        >
                          <input
                            type="checkbox"
                            checked={!!selected}
                            onChange={() => {}}
                            onClick={(e) => e.stopPropagation()}
                            className="h-5 w-5 accent-blue-600 ml-2 rounded-lg"
                          />
                          <div>
                            <img
                              className="w-12 h-12 rounded-full object-cover"
                              src={
                                user.imagepath
                                  ? fetchProfilePic(user.imagepath)
                                  : user1
                              }
                              alt=""
                            />
                          </div>
                          {/* Employee Info */}
                          <div className="flex-1">
                            <h4 className="font-medium text-slate-800">
                              {user.Name}
                              <span className="ml-2 text-xs font-normal text-slate-400">
                                ({user.EmpId})
                              </span>
                            </h4>
                            <p className="text-sm text-slate-500">
                              {user.JobTitle || "Employee"} •{" "}
                              {user.Department || "No Department"}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="sticky bottom-0 border-t bg-white px-8 py-4">
              <div className="flex justify-end gap-3">
                <button
                  onClick={closeTeamCreationModal}
                  className="rounded-xl border border-slate-300 px-6 py-2.5 font-medium text-slate-700 transition hover:bg-slate-100"
                >
                  Cancel
                </button>
                <Tooltip
                  title={
                    disableSaveTeam
                      ? "Please check for duplicate or blank Team name, Leader & Division before saving"
                      : editingTeam
                        ? "Update team details"
                        : "Create a new team"
                  }
                >
                  {/* <button
                    disabled={editingTeam ? disableEditTeam : disableSaveTeam}
                    onClick={saveTeam}
                    // className={`rounded-xl px-6 py-2.5 font-medium text-white transition hover:shadow-xl ${
                    //   disableSaveTeam
                    //     ? "bg-gray-400 cursor-not-allowed"
                    //     : "bg-gradient-to-r from-blue-600 to-indigo-600"
                    // }`}
                    className={`rounded-xl px-6 py-2.5 font-medium text-white transition hover:shadow-xl ${
                      editingTeam ? disableEditTeam : disableSaveTeam 
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-blue-600 to-indigo-600"
                    }`}
                  >
                    {editingTeam ? "Update Team" : "Create Team"}
                  </button> */}

                  <button
                    disabled={isButtonDisabled}
                    onClick={saveTeam}
                    className={`rounded-xl px-6 py-2.5 font-medium text-white transition ${
                      isButtonDisabled
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-blue-600 to-indigo-600 hover:shadow-xl"
                    }`}
                  >
                    {editingTeam ? "Update Team" : "Create Team"}
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Master Popup (Codes & Types Management) */}
      {showMasterPopup && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-[95%] max-w-xl rounded-2xl bg-white shadow-2xl p-6 max-h-[75vh] overflow-y-auto scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <div>
                <h2 className="flex items-center gap-2 text-lg font-semibold text-blue-600">
                  <Users className="text-blue-600" />
                  {masterType === "TEAM_CODE"
                    ? "TEAM CODE MANAGEMENT"
                    : "TEAM TYPE MANAGEMENT"}
                </h2>
                <p className="mt-1 text-sm text-gray-500">
                  {masterType === "TEAM_CODE"
                    ? "Create and manage team codes"
                    : "Create and manage team types"}
                </p>
              </div>
              <button
                onClick={() => {
                  setShowMasterPopup(false);
                  setMasterInputEdit({
                    description: "",
                    transaction_id: "",
                  });
                  setMasterInputNew({
                    description: "",
                  });
                }}
                className="rounded-full p-2 hover:bg-gray-100 transition"
              >
                <CloseIcon />
              </button>
            </div>
            {/* Add New */}
            <div className="mt-6">
              <label className="mb-2 block text-sm font-medium text-gray-700">
                {masterType === "TEAM_CODE" ? "New Team Code" : "New Team Type"}
              </label>
              <div className="flex flex-col gap-3 sm:flex-row">
                <input
                  type="text"
                  value={masterInputNew.description}
                  placeholder={
                    masterType === "TEAM_CODE"
                      ? "Enter Team Code..."
                      : "Enter Team Type..."
                  }
                  onChange={(e) =>
                    setMasterInputNew((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
                />
                <button
                  type="button"
                  onClick={() => {
                    if (masterType === "TEAM_CODE") {
                      createTeamCode();
                    } else {
                      createTeamType();
                    }
                  }}
                  className="inline-flex items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2 font-medium text-white transition hover:bg-blue-700"
                >
                  <Plus size={16} />
                  Add
                </button>
              </div>
            </div>
            {/* List */}
            <div className="mt-6 space-y-3">
              {activeMasterList?.map((item) => {
                const isEditing =
                  masterInputEdit.transaction_id === item.TranId;
                return (
                  <div
                    key={item.TranId}
                    className="rounded-xl border border-gray-200 py-1 px-2 transition hover:shadow-md"
                  >
                    {!isEditing ? (
                      <div className="flex items-center justify-between">
                        <div>
                          <h4 className="font-medium text-gray-800">
                            {item.Description}
                          </h4>
                          {/* <p className="text-xs text-gray-400">
                            ID: {item.TranId}
                          </p> */}
                        </div>
                        <button
                          type="button"
                          onClick={() =>
                            setMasterInputEdit({
                              description: item.Description,
                              transaction_id: item.TranId,
                            })
                          }
                          className="rounded-lg p-2 hover:bg-gray-100 transition"
                        >
                          <EditIcon
                            fontSize="small"
                            className="text-gray-600"
                          />
                        </button>
                      </div>
                    ) : (
                      <div>
                        <div className="flex flex-col gap-3 sm:flex-row">
                          <input
                            type="text"
                            value={masterInputEdit.description}
                            onChange={(e) =>
                              setMasterInputEdit((prev) => ({
                                ...prev,
                                description: e.target.value,
                              }))
                            }
                            className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
                          />
                          <div className="flex gap-2">
                            <button
                              type="button"
                              onClick={() =>
                                setMasterInputEdit({
                                  description: "",
                                  transaction_id: "",
                                })
                              }
                              className="flex items-center gap-1 rounded-lg border border-gray-300 px-3 py-2 text-gray-600 hover:bg-gray-100 transition"
                            >
                              <CancelIcon fontSize="small" />
                              Cancel
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                if (masterType === "TEAM_CODE") {
                                  updateTeamCode();
                                } else {
                                  updateTeamType();
                                }
                              }}
                              className="flex items-center gap-1 rounded-lg bg-green-600 px-3 py-2 text-white hover:bg-green-700 transition"
                            >
                              <SaveIcon fontSize="small" />
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
              {(!activeMasterList || activeMasterList.length === 0) && (
                <div className="rounded-xl border border-dashed border-gray-300 py-10 text-center">
                  <p className="text-gray-500">
                    No{" "}
                    {masterType === "TEAM_CODE" ? "Team Codes" : "Team Types"}{" "}
                    found
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteModalOpen && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
            <div className="flex flex-col items-center text-center">
              <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
                <Trash2 size={30} className="text-red-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-800">
                Delete Team
              </h3>
              <p className="mt-2 text-sm text-slate-500">
                Are you sure you want to delete
                <span className="font-semibold text-slate-700">
                  {" "}
                  {teamToDelete?.TeamName || teamToDelete?.name}
                </span>
                ?
              </p>
              <p className="mt-1 text-xs text-red-500">
                This action cannot be undone.
              </p>
              <div className="mt-6 flex w-full gap-3">
                <button
                  onClick={() => {
                    setDeleteModalOpen(false);
                    setTeamToDelete(null);
                  }}
                  className="flex-1 rounded-xl border border-slate-300 py-2.5 font-medium text-slate-700 transition hover:bg-slate-100"
                >
                  Cancel
                </button>
                <button
                  onClick={deleteTeam}
                  className="flex-1 rounded-xl bg-red-600 py-2.5 font-medium text-white transition hover:bg-red-700"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamManagement;
